export default "__VITE_ASSET__D83PGJdO__"